__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "shell";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@headless-shell/store", "1.0.0", () => (() => (__webpack_require__(5256))), 1);
			register("@reduxjs/toolkit/query/react", "2.13.0", () => (() => (__webpack_require__(1201))), 1);
			register("@reduxjs/toolkit", "2.13.0", () => (() => (__webpack_require__(3939))), 1);
			register("react-dom/client", "19.3.0", () => (() => (__webpack_require__(5873))), 1);
			register("react-dom", "19.3.0", () => (() => (__webpack_require__(3144))), 1);
			register("react-redux", "9.3.0", () => (() => (__webpack_require__(7306))), 1);
			register("react-router-dom", "7.18.4", () => (() => (__webpack_require__(8962))), 1);
			register("react", "19.3.0", () => (() => (__webpack_require__(4041))), 1);
			register("styled-components", "6.5.3", () => (() => (__webpack_require__(3495))), 1);
			initExternal(7160);
			initExternal(17);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};